export default {
    NOT_ADD:'No, they don\'t',
    IS_EXIST:'Yes, they do',
    TO_CREATE:'No, let\'s give them {{type}}'
}